import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Center, Title, Text, Stack } from "@mantine/core";
import { useAuth } from "@bi-studio/shared/hooks";

export default function RootPage() {
    const navigate = useNavigate();
    const { isAuthenticated, isLoading } = useAuth();

    useEffect(() => {
        if (isLoading) return;

        if (isAuthenticated) {
            navigate("/folders");
        } else {
            navigate("/login");
        }
    }, [navigate, isAuthenticated, isLoading]);

    return (
        <Center h="100vh">
            <Stack align="center">
                <Title order={1}>Welcome to BI Studio</Title>
                <Text c="dimmed">Redirecting...</Text>
            </Stack>
        </Center>
    );
}
